/**
 * Zoy Product Accordion
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-zoy-accordion]').forEach(function (list) {
    var singleOpen = list.hasAttribute('data-single');
    var items = list.querySelectorAll('[data-zoy-accordion-item]');

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-zoy-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (singleOpen) {
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var t = i.querySelector('[data-zoy-accordion-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
})();
